import * as React from 'react';
import sanitize from 'sanitize-html';

import { UIText2 } from '@cian/ui-kit';

export interface IDescriptionProps {
  description: string;
  isBooked?: boolean;
}

export function Description({ description, isBooked }: IDescriptionProps) {
  const sanitizeDescription = sanitize(description, {
    allowedTags: ['b', 'i', 'em', 'strong', 'a'],
    allowedAttributes: {
      a: ['href'],
    },
    allowedSchemesByTag: {
      a: ['http', 'https', 'mailto'],
    },
  });

  return (
    <UIText2 color={isBooked ? 'text-secondary-default' : 'text-primary-default'}>
      {/* eslint-disable-next-line react/no-danger */}
      <span dangerouslySetInnerHTML={{ __html: sanitizeDescription }} />
    </UIText2>
  );
}
